import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { useCart } from "@/context/CartContext";

export default function PaymentReturn() {
  const [params] = useSearchParams();
  const { lang } = useI18n();
  const { clear } = useCart();
  const [state, setState] = useState("checking");
  const sessionId = params.get("session_id");
  const isShop = !!localStorage.getItem("jd_pending_shop");

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          if (localStorage.getItem("jd_pending_shop")) { clear(); localStorage.removeItem("jd_pending_shop"); }
          setState("success"); return;
        }
        if (data.status === "expired") { setState("expired"); return; }
      } catch { setState("error"); return; }
      if (attempts++ < 6) setTimeout(poll, 2000);
      else setState("pending");
    };
    poll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  const M = {
    checking: [Loader2, lang === "de" ? "Zahlung wird geprüft…" : "Checking payment…", true],
    success: [CheckCircle2, lang === "de" ? "Zahlung erfolgreich!" : "Payment successful!"],
    pending: [Loader2, lang === "de" ? "Zahlung wird verarbeitet…" : "Payment processing…", true],
    expired: [XCircle, lang === "de" ? "Sitzung abgelaufen." : "Session expired."],
    error: [XCircle, lang === "de" ? "Fehler bei der Zahlung." : "Payment error."],
  };
  const [Icon, msg, spin] = M[state];
  const to = isShop ? "/portal/purchases" : "/portal/invoices";
  const label = isShop ? (lang === "de" ? "Zu meinen Käufen" : "To my purchases") : (lang === "de" ? "Zu meinen Rechnungen" : "To my invoices");
  return (
    <div className="container-x py-32 text-center max-w-md mx-auto">
      <Icon size={56} className={`mx-auto mb-6 ${state === "success" ? "text-primary" : "text-muted-foreground"} ${spin ? "animate-spin" : ""}`} />
      <h1 className="font-display text-2xl font-black" data-testid="payment-status">{msg}</h1>
      <Link to={to} className="btn-primary mt-8" data-testid="payment-back">{label}</Link>
    </div>
  );
}
